import { createFileRoute } from '@tanstack/react-router';

import { requireAuth } from '@/app/lib/auth-guard';
import HomePage from '@/home/pages';

export const Route = createFileRoute('/')({
  beforeLoad: async (ctx) => {
    await requireAuth(ctx);
  },
  component: HomeRoute,
  onEnter: () => {},
  staticData: {
    headerSection: 'home'
  }
});

function HomeRoute() {
  return <HomePage/>;
}
